import React from 'react';
import Button from 'material-ui/Button';
import {
    Divider,
    Typography,
    Grid
} from 'material-ui';
import {Link} from 'react-router-dom';

export const Heading = (props) => {

    const {
        title,
        buttonTitle,
        buttonAction,
        showButton,
        disabled
    } = props;
    
    let HeadingButton = null;
    
    if (typeof showButton === 'function') {
        HeadingButton = showButton(() =>
            <Grid item xs={6}>
                {typeof buttonAction === "function" &&
                    <Button className="floatRight" variant="raised" color="primary" aria-label="add" onClick={buttonAction} disabled={disabled}>
                        {buttonTitle}
                    </Button>
                }
                {buttonAction === 'redirects/new' &&
                    <Button className="floatRight bulkRedirects" component={Link} to={'redirects/bulk'} variant="raised" color="primary" aria-label="add" disabled={disabled}>
                        Add bulk redirects
                    </Button>
                }
                {typeof buttonAction === "string" &&
                    <Button className="floatRight" component={Link} to={buttonAction} variant="raised" color="primary" aria-label="add" disabled={disabled}>
                        {buttonTitle}
                    </Button>
                }
            </Grid>
        );
    }

    return (
        <Grid container className="headingWrapper">
            <Grid item xs={6}>
                <Typography variant="headline">{title}</Typography>
            </Grid>
            {typeof showButton === 'function' && <HeadingButton />}
            <Grid item xs={12}>
                <Divider />
            </Grid>
        </Grid>
    )
}


// WEBPACK FOOTER //
// ./src/components/heading/heading.js